import React from 'react';

import { css } from '@emotion/react';
import { TailSpin } from 'react-loader-spinner';

import { palette } from '@styles/theme';

interface Props {
    type?: 'full' | 'inside';
}

const LoadingSpinner = ({ type = 'full' }: Props) => {
    return (
        <div css={[type === 'full' ? container : inside]}>
            <div css={[modal, type === 'inside' && insideModal]}>
                <TailSpin
                    color={palette.primaryColor}
                    width={60}
                    height={60}
                    radius={1}
                />
            </div>
        </div>
    );
};

export default LoadingSpinner;

const container = css`
    display: flex;
    align-items: center;
    justify-content: center;

    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 10001;
    background-color: rgba(0, 0, 0, 0.5);
`;

const inside = css`
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
`;

const modal = css`
    position: relative;
    width: 120px;
    height: 100px;
    background-color: #ffffff;
    box-shadow: 0px 5px 16px rgba(0, 0, 0, 0.08);
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
`;

const insideModal = css`
    width: auto;
    height: auto;
    box-shadow: none;
`;
